import React, { useState } from 'react';
import '../../css/modal.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (paymentData: {
    amount: number;
    method: string;
    transactionId: string;
    notes?: string;
  }) => void;
  defaultAmount?: number;
}

const AddPaymentModal: React.FC<Props> = ({ isOpen, onClose, onSubmit, defaultAmount }) => {
  const [amount, setAmount] = useState(defaultAmount || 0);
  const [method, setMethod] = useState('upi');
  const [transactionId, setTransactionId] = useState('cash');
  const [notes, setNotes] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ amount, method, transactionId, notes });
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <button className="close-btn" onClick={onClose}>×</button>
        <h3>Add Payment</h3>
        <form onSubmit={handleSubmit} className="form">
          <label>
            Amount:
            <input type="number" value={amount} onChange={e => setAmount(+e.target.value)} required />
          </label>

          <label>
            Method:
            <select value={method} onChange={e => setMethod(e.target.value)}>
              <option value="upi">UPI</option>
              <option value="cash">Cash</option>
              <option value="card">Card</option>
              <option value="netbanking">Netbanking</option>
            </select>
          </label>

          <label>
            Transaction ID:
            <input type="string" value={transactionId} onChange={e => setTransactionId(e.target.value)} required />
          </label>

          <label>
            Notes:
            <textarea value={notes} onChange={e => setNotes(e.target.value)} />
          </label>

          <button type="submit" className="primary-btn">Submit Payment</button>
        </form>
      </div>
    </div>
  );
};

export default AddPaymentModal;
